import * as React from 'react'

interface SkeletonProps {
  /** shape and size come from the caller, e.g. "h-4 w-24 rounded" */
  className?: string
}

/** Pulsing grey placeholder. Callers supply the shape. */
export const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} aria-hidden="true" />
)
